export default __webpack_public_path__ + "static/media/Vector (1).e4c32643.svg";